/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * PUT /distributors/{id}
 * @export
 * @interface PutDistributorSuccessResponse
 */
export interface PutDistributorSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof PutDistributorSuccessResponse
     */
    status: number;
    /**
     * エラーメッセージ。原則英語。
     * @type {string}
     * @memberof PutDistributorSuccessResponse
     */
    message: string;
}

export function PutDistributorSuccessResponseFromJSON(json: any): PutDistributorSuccessResponse {
    return PutDistributorSuccessResponseFromJSONTyped(json, false);
}

export function PutDistributorSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutDistributorSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function PutDistributorSuccessResponseToJSON(value?: PutDistributorSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

